import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from 'components';
import { formatDateWithMonthYear } from 'utils';
import { contractsUtils } from 'api/services/contracts';
import './MilestoneTable.scss';

const MilestoneTable = ({
  milestones = [],
  onTimelineChange,
  showAdjustedTimeline = true,
}) => {
  if (!milestones || milestones.length === 0) {
    return (
      <div className='milestone-table milestone-table--empty'>
        <p>No milestones available</p>
      </div>
    );
  }

  return (
    <div className='milestone-table'>
      <div className='milestone-table__header'>
        <span>Milestone</span>
        <span>Compensation</span>
        <span>Due Date</span>
        <span>Adjusted Timeline</span>
      </div>
      {milestones.map((milestone, index) => (
        <div key={milestone.id || index} className='milestone-table__row'>
          <span className='milestone-table__title'>{milestone.title}</span>
          <span className='money-style'>
            {contractsUtils.formatCurrency(milestone.amount_usd)}
          </span>
          <span className='milestone-table__date'>
            {milestone.due_date
              ? formatDateWithMonthYear(milestone.due_date)
              : 'Not set'}
          </span>

          {showAdjustedTimeline && (
            <DatePicker
              value={milestone?.adjusted_due_date?.split('T')[0]}
              onChange={(value) => onTimelineChange?.(index, value)}
              placeholder='Select date'
              ariaLabel={`Adjusted timeline for ${milestone.title}`}
              showCalendarButton={false}
            />
          )}
        </div>
      ))}
    </div>
  );
};

MilestoneTable.propTypes = {
  milestones: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string.isRequired,
      due_date: PropTypes.string,
      amount_usd: PropTypes.number,
      adjusted_due_date: PropTypes.string,
    })
  ),
  onTimelineChange: PropTypes.func,
  showAdjustedTimeline: PropTypes.bool,
};

export default MilestoneTable;
